/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForJiraServiceManagementChangeManagement extends models.GovernanceConfigurationBaseForJiraServiceManagement {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForJiraServiceManagementChangeManagement");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForJiraServiceManagementChangeManagement.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForJiraServiceManagementChangeManagement>): GovernanceConfigurationForJiraServiceManagementChangeManagement {
        let obj = Object.assign(new GovernanceConfigurationForJiraServiceManagementChangeManagement(), model);
        GovernanceConfigurationForJiraServiceManagementChangeManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForJiraServiceManagementChangeManagement>): GovernanceConfigurationForJiraServiceManagementChangeManagement {
        if (!model) return null;
        return GovernanceConfigurationForJiraServiceManagementChangeManagement.newInstance(<GovernanceConfigurationForJiraServiceManagementChangeManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForJiraServiceManagementChangeManagement) {
        if (!obj) return;

        models.GovernanceConfigurationForJiraServiceManagementChangeManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForJiraServiceManagementChangeManagement): boolean {
        if (models.GovernanceConfigurationBaseForJiraServiceManagement.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForJiraServiceManagementChangeManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.cost_recommendation_mapping) {
            models.JiraServiceManagementCostRecommendationMapping.fixupPrototype(this.cost_recommendation_mapping);
        }
    }

    /**
     *  Attribute mapping for Jira Service Management Cost Recommendation
     */
    cost_recommendation_mapping: models.JiraServiceManagementCostRecommendationMapping;

}
